import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { datepickerLocale } from "../../../lang";

import './styles.css';

import DateRangePicker from 'react-bootstrap-daterangepicker'

class SimpleDatePicker extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    handler(event, picker) {
        if (event.type === 'apply') {
            this.setState({
                startDate: picker.startDate,
                endDate: picker.endDate
            });

            this.props.datePickHandler(moment.utc(moment(picker.startDate).toDate()), moment.utc(picker.endDate).toDate())
        }
    }

    render() {
        return (
            <div className="date-picker-wrapper">

                <DateRangePicker
                    opens="left"
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    minDate={this.props.minDate ? moment(this.props.minDate) : null}
                    maxDate={this.props.maxDate ? this.props.maxDate : null}
                    onEvent={(event, picker) => this.handler(event, picker)}
                    ranges={this.props.ranges}
                    locale={datepickerLocale}
                >
                    <button className="simple-date-picker-btn">
                        {this.props.label || 'Date'}
                    </button>
                </DateRangePicker>
            </div>
        )
    }
}

SimpleDatePicker.propTypes = {
    label: PropTypes.string,
    datePickHandler: PropTypes.func,
    minDate: PropTypes.oneOfType([
        PropTypes.string
    ]),
    maxDate: PropTypes.object,
    ranges: PropTypes.object
};

export default SimpleDatePicker;



// WEBPACK FOOTER //
// ./src/Components/Elements/Pickers/SimpleDatePicker.js